import { render } from "./ChannelButtonItem.vue?vue&type=template&id=f43fd81c&scoped=true"
import script from "./ChannelButtonItem.vue?vue&type=script&lang=js"
export * from "./ChannelButtonItem.vue?vue&type=script&lang=js"

import "./ChannelButtonItem.vue?vue&type=style&index=0&id=f43fd81c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43fd81c"]])

export default __exports__